<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mt-4">
      <div class="col-sm-6">
        <div class="media">
          <div class="avatar-sm mr-3">
            <span
              class="avatar-title rounded-circle bg-primary text-white font-size-22"
            >
              <i class="bx bxl-twitter"></i>
            </span>
          </div>
          <div class="media-body">
            <b class="text-muted mb-1"
              >{{ total_results }} {{ $t("twitter.account.text") }}</b
            >
            <h4>{{ $t("twitter.last-search-accounts.text") }}</h4>
          </div>
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <!-- <router-link to="/twitter-compare"
          ><b-button class="btn mr-1" variant="success"
            ><i class="bx bx-user-plus bx-xl"></i> Compare Account</b-button
          ></router-link
        > -->
        <router-link to="/tiktok/search"
          ><b-button class="btn" variant="primary"
            ><i class="bx bx-user-plus bx-xl"></i>
            {{ $t("twitter.add-new.text") }}</b-button
          ></router-link
        >
      </div>
    </div>
    <div class="row mt-2 mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("button.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-0"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("button.entries") }}
                  </label>
                  <b-button
                    class="btn btn-sm ml-3"
                    variant="danger"
                    @click="bulkAction()"
                    v-if="selected[0]"
                    >{{ $t("button.bulk") }} : {{ selected.length }}
                    {{ $t("button.row-data") }}</b-button
                  >
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("button.search-data") }}
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #head(bulk)>
                  <b-form-checkbox
                    v-model="selectAll"
                    @change="select"
                    class="text-center mt-0"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(no)="row">
                  <div class="mt-2">
                    {{ row.item.no }}
                  </div>
                </template>
                <template #cell(bulk)="row">
                  <b-form-checkbox
                    class="text-center mt-2"
                    v-model="selected"
                    :value="row.item.id_tiktok"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(account)="row">
                  <div class="col-sm-12">
                    <div class="media">
                      <img
                        :src="
                          'https://m-p16.akamaized.net/obj/' + row.item.picture
                        "
                        class="mr-3 mt-2 rounded-circle avatar-xs"
                        alt="user-pic"
                      />
                      <div class="media-body">
                        <a
                          :href="'https://www.tiktok.com/@' + row.item.account"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <b> {{ row.item.full_name }}</b>
                        </a>
                        <span v-if="row.item.verified == true"
                          ><i
                            class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"
                          ></i
                        ></span>
                        <br />
                        <span class="text-secondary">
                          @{{ row.item.account }}</span
                        >
                        <br />
                        <!-- <p class="text-secondary">{{ $t('all.updated') }}: {{row.item.updated_at}} </p>  -->
                      </div>
                    </div>
                  </div>
                </template>
                <!-- <template #cell(status)="row">  
                   <span class="badge badge-success p-1 px-1" variant="danger" v-if="row.item.status == 1"> Active</span>
                   <span class="badge badge-danger p-1 px-1" v-else-if="row.item.status == 0">Non Active</span>
                </template> -->
                <template #cell(pin)="row">
                  <span v-if="row.item.pin" @click="unpin(row.item.id_tiktok)">
                    <i class="bx bx-pin bx-sm text-primary"></i>
                  </span>
                  <span v-else @click="pin(row.item.id_tiktok)">
                    <i class="bx bx-pin bx-sm text-secondary"></i>
                  </span>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      name: 'tiktok-view',
                      params: { id: row.item.user_id },
                    }"
                    ><b-button
                      class="mr-1 btn-sm mb-1"
                      variant="secondary"
                      title="Show detail"
                    >
                      <i class="bx bx-show-alt"></i> </b-button
                  ></router-link>
                  <b-button
                    class="mr-2 btn-sm mb-1"
                    variant="danger"
                    @click="deleteTiktok(row.item.id_tiktok)"
                    title="Delete"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                </template>
              </b-table>

              <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                    v-if="loadingInfo"
                  ></div>
                </div>
              </div>
            </div>
            <div class="row" v-if="!loadingInfo && rows > 10">
              <div class="col-2 col-xl-1">
                <!-- <div v-if="selected[0]">
                      <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                    </div> -->
                <label class="d-inline-flex align-items-center">
                  Page
                  <b-form-input
                    v-model="currentPage"
                    placeholder="Page"
                    class="form-control w-10 form-control ml-2"
                  ></b-form-input>
                </label>
              </div>
              <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import TwintService from "@/helpers/twint.service.js";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import store from "@/state/store";
import moment from "moment";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Tiktok",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Carousel, Slide },
  data() {
    return {
      tableData: [],
      total_results: "",
      selected: [],
      selectedCompare: [],
      selectAll: false,
      search: false,
      loadingInfo: false,
      searchKey: "",
      title: "Tiktok",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Tiktok",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        {
          key: "bulk",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "#",
        },
        { key: "id_tiktok", thClass: "d-none", tdClass: "d-none" },
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        { key: "avatar", thClass: "d-none", tdClass: "d-none" },
        { key: "updated_at", thClass: "d-none", tdClass: "d-none" },
        { key: "name", thClass: "d-none", tdClass: "d-none" },
        {
          key: "account",
          sortable: true,
          label: this.$t("twitter.table.account"),
        },
        {
          key: "followers",
          sortable: true,
          label: this.$t("twitter.table.followers"),
        },
        {
          key: "following",
          sortable: true,
          label: this.$t("twitter.table.following"),
        },
        {
          key: "likes",
          sortable: true,
          label: this.$t("tiktok.likes"),
        },
        // { key: "pin", class: "text-center", label: "Pin" },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("twitter.table.action"),
        },
      ],
      activequery: "",
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    searchTiktok() {
      this.search = true;
    },
    select() {
      this.selected = [];
      this.selectedCompare = [];
      if (!this.selectAll) {
        for (let i in this.tableData) {
          this.selected.push(this.tableData[i].id_tiktok);
          this.selectedCompare.push(this.tableData[i].account);
        }
      }
    },
    lisTiktok() {
      this.loadingInfo = true;
      SocmedService.getAllTiktok()
        .then((response) => {
          this.tableData = [];
          this.total_results = response.data.data.length;
          response.data.data.forEach((val, index) => {
            const data = {
              no: index + 1,
              user_id: val.user_id,
              id_tiktok: val.id_tiktok,
              account: val.account,
              full_name: val.full_name,
              bio: val.bio,
              followers: val.followers,
              following: val.following,
              likes: val.likes,
              picture: val.picture,
              pin: "0",
              created_at: this.formatDate(val.created_at),
              updated_at: this.formatDate(val.updated_at),
            };
            this.tableData.push(data);
            this.loadingInfo = false;
          });
        })
        .catch((err) => {
          console.log(err);
          this.loadingInfo = false;
        });
    },
    deleteTiktok(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          SocmedService.deleteTiktok(id)
            .then((response) => {
              this.lisTiktok();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    bulkAction() {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = this.selected;
          SocmedService.deleteBulkTiktok(data)
            .then((response) => {
              this.selected = [];
              this.lisTiktok();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: this.$t("alert.alert-delete-twitter"),
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    // pin(id){
    //   const idt = btoa(id);
    //   Swal.fire({
    //       title: 'Pin',
    //       text: 'Pin Account',
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#34c38f",
    //       cancelButtonColor: "#f46a6a",
    //       cancelButtonText: this.$t('button.cancel.text'),
    //       confirmButtonText: 'Pin'
    //   }).then((result) => {
    //       if (result.isConfirmed) {
    //         console.log('id',  idt);
    //           SocmedService.pinTwitter(idt)
    //           .then( response => {
    //               this.lisTiktok();
    //               Swal.fire({
    //                   position: "top-end",
    //                   icon: "success",
    //                   title: response.data.message,
    //                   showConfirmButton: false,
    //                   timer: 1500
    //               });
    //           })
    //           .catch( err => {
    //               console.log(err);
    //           });
    //       }
    //   });
    // },

    // unpin(id){
    //   const idt = btoa(id);
    //   Swal.fire({
    //       title: 'Unpin',
    //       text: 'Unpin Account',
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#34c38f",
    //       cancelButtonColor: "#f46a6a",
    //       cancelButtonText: this.$t('button.cancel.text'),
    //       confirmButtonText: 'Unpin'
    //   }).then((result) => {
    //       if (result.isConfirmed) {
    //         console.log('id',  idt);
    //           SocmedService.unpinTwitter(idt)
    //           .then( response => {
    //               this.lisTiktok();
    //               Swal.fire({
    //                   position: "top-end",
    //                   icon: "success",
    //                   title: response.data.message,
    //                   showConfirmButton: false,
    //                   timer: 1500
    //               });
    //           })
    //           .catch( err => {
    //               console.log(err);
    //           });
    //       }
    //   });
    // },

    formatDate(value) {
      return moment(value).format("dddd, YYYY-MM-DD hh:mm");
    },
    formatNumber(count, decimals = 2) {
      const COUNT_ABBRS = ["", "K", "M", "B", "T"];
      const i =
        0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
      let result = parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
      result += `${COUNT_ABBRS[i]}`;
      return result;
    },
    diffTime(value) {
      const currTime = moment().format("HH:mm:ss");
      const lastTime = moment(value).format("HH:mm:ss");
      const startTime = moment.duration(currTime, "HH:mm:ss");
      const endTime = moment.duration(lastTime, "HH:mm:ss");
      const diff = startTime.subtract(endTime);
      this.trends24.last_update = diff._data;
    },
    onHover(id) {
      this.activequery = id;
    },
    onLeave() {
      this.activequery = "";
    },
  },
  mounted() {
    console.log("ref ==> ", this.$refs);
    this.totalRows = this.items.length;
    this.lisTiktok();
  },
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
/* .my-custom-scrollbar {
position: relative;
height: 700px;
overflow: auto;
}
.table-wrapper-scroll-y {
display: block;
} */
</style>
